import { useTranslation } from "react-i18next";
import { useCurrency, SUPPORTED_CURRENCIES } from "../context/CurrencyContext";
import { SUPPORTED_LANGUAGES } from "../i18n";
import { Globe, DollarSign } from "lucide-react";

export default function LanguageCurrencySelector({ compact = false }) {
  const { i18n } = useTranslation();
  const { currency, setCurrency } = useCurrency();

  return (
    <div className="flex items-center gap-2" data-testid="lang-currency-selector">
      <div className="relative inline-flex items-center">
        <Globe className="w-3.5 h-3.5 text-text-secondary absolute left-2 pointer-events-none" />
        <select
          value={i18n.language?.split("-")[0] || "en"}
          onChange={(e) => i18n.changeLanguage(e.target.value)}
          data-testid="lang-select"
          className="tray-inset bg-transparent text-white font-mono-data text-xs uppercase tracking-widest pl-7 pr-2 py-1.5 outline-none cursor-pointer appearance-none"
          style={{ direction: "ltr" }}
        >
          {SUPPORTED_LANGUAGES.map(l => (
            <option key={l.code} value={l.code} className="bg-black">{compact ? l.flag : l.label}</option>
          ))}
        </select>
      </div>
      <div className="relative inline-flex items-center">
        <DollarSign className="w-3.5 h-3.5 text-text-secondary absolute left-2 pointer-events-none" />
        <select
          value={currency}
          onChange={(e) => setCurrency(e.target.value)}
          data-testid="currency-select"
          className="tray-inset bg-transparent text-white font-mono-data text-xs uppercase tracking-widest pl-7 pr-2 py-1.5 outline-none cursor-pointer appearance-none"
          style={{ direction: "ltr" }}
        >
          {SUPPORTED_CURRENCIES.map(c => (
            <option key={c.code} value={c.code} className="bg-black">{c.code}</option>
          ))}
        </select>
      </div>
    </div>
  );
}
